import moment from 'moment';

import mediaAvailabilitiesAPI from 'media-base-ui/utils/mediaAvailabilitiesAPI';
import actionCreators from './actionCreators';

const NHL_TEAM_ID = 99;

const fetchMediaAvailabilities = (date) => async dispatch => {
    dispatch(actionCreators.requestMediaAvailabilities());

    try {
        const { data } = await mediaAvailabilitiesAPI.fetchMediaAvailabilitiesData({date});
        let reorderedData = [...data];

        // We have to re-sort to make sure that minutes after game availabilities appear at the end of the list.
        reorderedData.sort((a, b) => {
            const teamDiff = a.team.fullName.localeCompare(b.team.fullName);
            if (teamDiff === 0) {
                if (a.time === null && b.time === null) {
                    return a.minutesAfterGame - b.minutesAfterGame;
                } else if (a.time === null) {
                     return 1;
                 } else if (b.time === null) {
                    return -1;
                } else {
                     return moment(a.time).valueOf() - moment(b.time).valueOf();
                 }
            }
            return teamDiff;
        });

        // re-order list to put NHL as first 'team'
        const nhlAvailabilities = reorderedData.filter(availability => availability.team.id === NHL_TEAM_ID);

        if (nhlAvailabilities.length > 0) {
            nhlAvailabilities.forEach(availability => availability.team.fullName = 'National Hockey League');
            reorderedData = [...nhlAvailabilities, ...(reorderedData.filter(availability => availability.team.id !== NHL_TEAM_ID))];
        }

        reorderedData.forEach((mediaAvailability) => {
            mediaAvailability.games = [...mediaAvailability.team.homeGames, ...mediaAvailability.team.awayGames];
        });

        dispatch(actionCreators.mediaAvailabilitiesResponse(true, reorderedData, []));
    } catch (error) {
        dispatch(actionCreators.mediaAvailabilitiesResponse(false, [], error));
    }
};

export default {
    fetchMediaAvailabilities,
};
